<template>
  <div class="container-fluid mt-2">
    <h2>Berichte</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button class="btn btn-secondary" id="prev"><font-awesome-icon icon="chevron-left"/></button>
        <button class="btn btn-secondary" id="next"><font-awesome-icon icon="chevron-right"/></button>
      </div>
      <button id="new" @click="createReport()" class="btn btn-primary">Hinzuf&uuml;gen</button>
    </div>
    <b-table @row-clicked="openReport" class="mt-3" striped hover :fields="fields" :items="rows">
      <template v-slot:cell(type)="data">
        {{ types[data.item.type] }}
      </template>
      <template v-slot:cell(action)="data">
        <font-awesome-icon @click="deleteReport(data.item.id)" icon="trash"/>
      </template>
    </b-table>
  </div>
</template>

<script>
import router from '../../router'
import reports from '@/modules/reports.js'

export default {
  name: 'ReportList',
  data() {
    return {
      types: ['Normal','Vertreter','Kunden','PDF Katalog'],
      fields: [
        { key: 'id', label: 'ID'},
        { key: 'name', label: 'Name'},
        { key: 'output', label: 'Ausgabe'},
        { key: 'format', label: 'Format' },
        { key: 'type', label: 'Type' },
        { key: 'lexec', label: 'Aktualisiert' },
        { key: 'lerror', label: 'Fehler' },
        { key: 'action', label: 'Aktion' },
      ],
      rows: [],
      delid: false,
    }
  },
  created: function() {
    this.fetchData();
  },
  methods: {
    fetchData: function() {
      var self = this;
      reports.list(function(data) {
        self.rows = data;
      });
    },
    deleteReport: function(id) {
      this.delid = id;
    },
    createReport: function() {
      router.push('/reports/new');
    },
    openReport: function(row,idx) {
      console.log('del : ' + this.delid);
      if (this.delid && this.delid > 0 && this.delid == row.id) {
        if (confirm('Möchten Sie wirklich den Bericht (' + row.name + ') löschen?')) {
          var self = this;
          reports.delete(this,this.delid,function() {
            self.$bvToast.toast('Bericht gelöscht!',{title: 'Berichte',variant: 'success'});
            self.rows.splice(idx,1)
          })
        }
        return;
      }
      this.delid = false;
      router.push('/reports/' + row.id);
    }
  }
}

</script>
